import { IPersonaProps } from '@fluentui/react';
import { atom } from 'recoil';

export const aIsBackgroundDialogOpen = atom<boolean>({ key: 'aIsBackgroundDialogOpen', default: false });
export const aCampusMembers = atom<IPersonaProps[]>({ key: 'aCampusMembers', default: [] });
